
export class AudioManager {
  constructor() {
    this.ctx = null;
    this.buffers = new Map();
    this.enabled = true;
  }

  /**
   *  Must be done after first user gesture because browser constraints
   */
  createContext() {
    if (this.ctx) return;
    this.ctx = new (window.AudioContext || window.webkitAudioContext)();
  }

  async load(name, url) {
    const res = await fetch(url);
    const arrayBuffer = await res.arrayBuffer();
    const audioBuffer = await this.ctx.decodeAudioData(arrayBuffer);
    this.buffers.set(name, audioBuffer);
  }

  /**
   *  TODO: catch if ctx suspends :) is this even an issue on iOS??
   */
  play(name, { volume = 1.0, rate = 1.0 } = {}) {
    if (!this.enabled) return;
    const buffer = this.buffers.get(name);
    if (!buffer) return;

    const source = this.ctx.createBufferSource();
    source.buffer = buffer;
    source.playbackRate.value = rate;

    const gain = this.ctx.createGain();
    gain.gain.value = volume;

    source.connect(gain);
    gain.connect(this.ctx.destination);
    source.start();
  }
}

